import { render } from "./CheckDestination.vue?vue&type=template&id=187dcf65&ts=true"
import script from "./CheckDestination.vue?vue&type=script&lang=ts"
export * from "./CheckDestination.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__